__turbopack_context__.v({
  "actionContainer": "ProductGridSection-module-scss-module__kJTyya__actionContainer",
  "header": "ProductGridSection-module-scss-module__kJTyya__header",
  "root": "ProductGridSection-module-scss-module__kJTyya__root",
});
